export const CABIN_CLASS_CATEGORY = 'cabinClass';
export const COMPANIES_CATEGORY = 'companies';
export const LAYOVERS_CATEGORY = 'layovers';
export const TIME_RANGES_CATEGORY = 'timeRanges';

export const CABIN_CLASS_ECO = 'ECO';
export const CABIN_CLASS_BUSINESS = 'BUSINESS';

export const ZERO_LAYOVERS_ICON = 'noStop';
export const ONE_LAYOVERS_ICON = '1Stop';
export const TWO_LAYOVERS_ICON = '2Stops';
